import { TableColumn } from '../../table/DataTable.types';

export const columns: TableColumn[] = [
  {
    accessor: 'name',
    name: 'page.company.col-name',
  },
  {
    accessor: 'description',
    name: 'page.company.col-description',
  },
];
